import cacheAngularTemplate from 'cacheAngularTemplate';
import { react2Angular } from 'FrontRoyalReact2Angular';
import { CertCongratsModal } from 'ExecEdEligibility/components/CertCongratsModal/CertCongratsModal';
import { ExecEdEligibilityBundleBox } from 'ExecEdEligibility';
import admissionsInfoBoxDesktopTemplate from '../views/admissions_info_box_desktop.html';
import admissionsInfoBoxMobileTemplate from '../views/admissions_info_box_mobile.html';
import ScheduleTemplate from '../views/schedule_box.html';
import ScheduleStatusTemplate from '../views/schedule_status_box.html';
import upcomingEventsBoxDesktopTemplate from '../views/upcoming_events_box_desktop.html';
import LateProjectSubmissionTemplate from '../views/late_project_submission_box.html';
import { EnrollmentBox } from '../../EnrollmentBox/EnrollmentBox';
import { IdVerificationBox } from '../../IdVerificationBox/IdVerificationBox';
import { OfflineBox } from '../../OfflineBox/OfflineBox';
import { ScheduleInterviewBox } from '../../ScheduleInterviewBox/ScheduleInterviewBox';

const angularModule = angular.module('AdmissionsGuidance', ['FrontRoyal.Users']);

cacheAngularTemplate(angularModule, 'AdmissionsGuidance/admissionsInfoBoxDesktop', admissionsInfoBoxDesktopTemplate);
cacheAngularTemplate(angularModule, 'AdmissionsGuidance/admissionsInfoBoxMobile', admissionsInfoBoxMobileTemplate);
cacheAngularTemplate(angularModule, 'AdmissionsGuidance/Schedule', ScheduleTemplate);
cacheAngularTemplate(angularModule, 'AdmissionsGuidance/ScheduleStatus', ScheduleStatusTemplate);
cacheAngularTemplate(
    angularModule,
    'AdmissionsGuidance/thisWeekInSlackDesktop',
    `<ul name="exercises" class="slack-schedule">
        <li ng-repeat="exercise in exercises | orderBy: 'date'">
            {{exercise.date | amDateFormat:'dddd, MMMM D'}} {{'lessons.stream.student_dashboard_schedule.at' | translate}} {{exercise.date | amDateFormat:'h:mm A'}}
            <span
                translate-once="lessons.stream.student_dashboard_schedule.in_the_room"
                translate-values="{room: exercise.channel}"
            ></span>
        </li>
    </ul>`,
);
cacheAngularTemplate(angularModule, 'AdmissionsGuidance/upcomingEventsBoxDesktop', upcomingEventsBoxDesktopTemplate);
cacheAngularTemplate(angularModule, 'AdmissionsGuidance/LateProjectSubmission', LateProjectSubmissionTemplate);
cacheAngularTemplate(
    angularModule,
    'AdmissionsGuidance/RecentCoursesBoxDesktop',
    `<course-list-box
        courses="recentCourses"
        open-stream-dashboard="openStreamDashboard"
        stream-available="streamAvailable"
        event-name="'student-dashboard:recent-courses'">
        </course-list-box>`,
);

angularModule.component(
    'certCongratsModal',
    react2Angular(CertCongratsModal, ['currentUser', 'filteredEligibilityBundle', 'programTypeConfigs', 'loadUrl'], ''),
);
angularModule.component(
    'execEdEligibilityBundleBox',
    react2Angular(ExecEdEligibilityBundleBox, ['filteredEligibilityBundle', 'showCertCongratsModal'], ''),
);
angularModule.component('enrollmentBox', react2Angular(EnrollmentBox, [], ''));
angularModule.component('idVerificationBox', react2Angular(IdVerificationBox, [], ''));
angularModule.component('offlineBox', react2Angular(OfflineBox, [], ''));
angularModule.component('scheduleInterviewBox', react2Angular(ScheduleInterviewBox, ['preRecorded'], ''));

export default angularModule;
